import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  console.log('NotFound component rendered'); // Debugging line
  return (
    <div className="not-found affilizone-Content">
      <div className="container">

      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you’re looking for doesn’t exist.</p>
      <Link to="/" className="home-link">Go to Home Page</Link>
      </div>
    </div>
  );
}

export default NotFound;
